import { _ } from "../polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";
import jQuery from "jquery";
import popoverActionButtonWidget from "./popoverActionButtonWidget.js";
import SearchFieldWidget from "./SearchFieldWidget/SearchFieldWidget.js";
import TreeWidget from "./tree/TreeWidget/TreeWidget.js";

/**
 * Deprecated. This class will be removed once we have multiple dimensions
 * selection through the entire application.
 *
 * For new dimension pickers, use `multipleDimensionsPickerWidget`.
 */
function dimensionPickerWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.cssClass = spec.cssClass || "btn-block btn-default";

	my.dimensionTree = spec.dimensionTree;
	my.selectedDimension = spec.selectedDimension || null;
	my.dataTestName = spec.dataTestName;
	my.selectLeavesOnly = spec.selectLeavesOnly || false;

	that.onDimensionSelected = my.events.createEvent();

	my.popoverButton = popoverActionButtonWidget({
		label: (html) => html.render(that.getSelectedDimensionName()),
		popoverHeader: _("Select dimension"),
		popoverContent: renderDimensionTreeOn,
		popoverPrimaryButtonLabel: _("Select dimension"),
		popoverAction: selectDimension,
	});

	my.tree = new TreeWidget({
		data: [null, my.dimensionTree],
		getLabel: (dimension) => my.dimensionName(dimension),
		autoOpen: 1,
		getChildren: (dimension) =>
			(dimension && dimension.getChildren()) || [],
		getId: (dimension) => dimension && dimension.getId(),
		canBeSelected: (dimension) =>
			!dimension || // the "Entire Business" can always be selected
			!my.selectLeavesOnly || // any dimension can be selected
			dimension.isLeaf(),
	});

	my.tree.selectNode(my.selectedDimension);

	my.tree.onSelectionChange.register(() => {
		const moveButton = jQuery(".popover .footer .btn-primary").get(0);

		if (my.tree.hasSelection()) {
			jQuery(moveButton).removeAttr("disabled");
		} else {
			jQuery(moveButton).attr("disabled", "disabled");
		}
	});

	my.searchField = new SearchFieldWidget({
		inputId: my.nextId(),
		inputClass: "form-control search-input",
	});

	my.searchField.applySearchOn(my.tree);

	that.getSelectedDimension = function () {
		return my.selectedDimension;
	};

	that.getSelectedDimensionName = function () {
		return my.dimensionName(my.selectedDimension);
	};

	that.getSelectedDimensionId = function () {
		return my.selectedDimension && my.selectedDimension.getId();
	};

	that.setSelectedDimension = function (dimension) {
		my.selectedDimension = dimension;
		my.tree.selectNode(my.selectedDimension);
		that.update();
	};

	that.setDimensionTree = function (dimensionTree) {
		my.dimensionTree = dimensionTree;

		if (my.selectedDimension) {
			// Switching to a matching dimension if possible
			const matchingDimensionId = my.selectedDimension.getId();
			const matchingDimension =
				dimensionTree.findById(matchingDimensionId);
			if (matchingDimension) {
				my.selectedDimension = matchingDimension;
			} else {
				my.warning(
					_(
						"The previously selected object cannot be found in the new year. No object is selected now",
					),
				);
			}
		}

		my.tree.setData([null, my.dimensionTree]);
		that.update();
	};

	that.pathString = function () {
		return my.selectedDimension
			? my.dimensionTree.pathNameToChildId(my.selectedDimension.getId())
			: "";
	};

	that.renderContentOn = function (html) {
		html.render({ "data-test": my.dataTestName }, my.popoverButton);
	};

	function renderDimensionTreeOn(html) {
		html.div({ klass: "form-group" }, my.searchField);
		html.render(my.tree);
	}

	my.dimensionName = function (dimension) {
		return dimension ? dimension.getLabel() : _("Entire Business");
	};

	function selectDimension() {
		my.selectedDimension = my.tree.selectedNode();
		that.update();
		that.onDimensionSelected.trigger(my.selectedDimension);
	}

	return that;
}

export default dimensionPickerWidget;
